import Vue from 'vue'
import Vuex from 'vuex'

const appliancesStore = {
  namespaced: true,
  state: {
    // This will change to be dynamic
    appliancesList: [],
    systemsList:[],
  },
  mutations: {
    SET_APPLIANCES_LIST(state, list) {
      state.appliancesList = list
    },

    SET_SYSTEMS_LIST(state, list) {
      state.systemsList = list
    }
  },
  actions: {
    reset({commit, state}) {
      commit('SET_APPLIANCES_LIST', [])
      commit('SET_SYSTEMS_LIST', [])
    },
    get({commit, state}) {
      var actualLanguage
      if(localStorage.language){actualLanguage =  localStorage.language}
      else{actualLanguage = 'FR'}


      return new Promise((resolve, reject) => {
        Vue.axios.get(`./rest/appliance/list?language=${actualLanguage}`)
        .then((response) => {
          commit('SET_APPLIANCES_LIST', response.data)
          resolve()
        })
        .catch( error => { reject(error) })
      })

    },

    getSystems({commit, state}) {
      var actualLanguage
      if(localStorage.language){actualLanguage =  localStorage.language}
      else{actualLanguage = 'FR'}

      return new Promise((resolve, reject) => {
        Vue.axios.get(`./rest/systems/list?language=${actualLanguage}`)
        .then((response) => {
          commit('SET_SYSTEMS_LIST', response.data)
          resolve()
        })
        .catch( error => { reject(error) })
      })
    },


  }
}

export default appliancesStore



// WEBPACK FOOTER //
// ./src/stores/appliances.js